<template>
  <section class="jumbotronWithSlider">
    <div class="container">
      <div class="slider">
        <div class="pagination">
          <button
            v-for="(slide, index) in slides"
            v-bind:key="index"
            :data-show="`${singleSlideClass}-${index}`"
            v-on:click="clickOnSlide(index)"
          >
            {{ index + 1 }}
          </button>
        </div>
        <div
          v-for="(slide, index) in slides"
          v-bind:key="index"
          :class="`${singleSlideClass} ${singleSlideClass}-${index}`"
        >
          <div class="slider-content">
            <h2>{{ slide.text }}</h2>
          </div>
          <a class="button" v-smooth-scroll :href="`${slide.buttonLink}`">{{
            slide.buttonText
          }}</a>
        </div>
        <div class="arrow">
          <a href="#about" role="presentation" v-smooth-scroll>
            <Arrow />
          </a>
        </div>
      </div>
    </div>
    <div class="LeafsContainer">
      <Leafs />
      <Leafs />
    </div>
  </section>
</template>

<script>
import Arrow from "@/components/svg/Arrow";
import Leafs from "@/components/svg/Leafs";

export default {
  name: "JumbotronWithSlider",
  props: {
    slides: Array,
  },
  components: {
    Arrow,
    Leafs,
  },
  data: () => {
    return {
      autoplayInterval: null,
      currentSlide: null,
      currentSlideIndex: 0,
      slider: null,
      slidesElements: null,
      visibleClass: "visible",
      activeClass: "active",
      existClass: "exist",
      singleSlideClass: "slide",
      timeouts: [],
    };
  },
  methods: {
    getSlideClass(index) {
      return `slide-${index}`;
    },
    setPaginationClass() {
      this.pagination.querySelector(`.${this.activeClass}`) &&
        this.pagination
          .querySelector(`.${this.activeClass}`)
          .classList.remove(this.activeClass);
      const button = this.pagination.querySelectorAll("button");
      button[this.currentSlideIndex].classList.add(this.activeClass);
    },
    hideSlides() {
      this.slider.querySelector(`.${this.visibleClass}`) &&
        this.slider
          .querySelector(`.${this.visibleClass}`)
          .classList.remove(this.visibleClass);
      this.timeouts.push(
        setTimeout(() => {
          this.slider.querySelector(`.${this.existClass}`) &&
            this.slider
              .querySelector(`.${this.existClass}`)
              .classList.remove(this.existClass);
        }, 300)
      );
    },
    addClassAfterTimeout(element, classToAdd, timeout) {
      this.timeouts.push(
        setTimeout(() => element.classList.add(classToAdd), timeout)
      );
    },
    showSlide(currentSlideIndex = 0) {
      this.timeouts.map((timeout) => clearTimeout(timeout));
      this.setCurrentIndex(currentSlideIndex);
      this.setPaginationClass();
      this.setCurrentSlide();
      if (!this.currentSlide.classList.contains(this.visibleClass)) {
        this.hideSlides();
        this.addClassAfterTimeout(this.currentSlide, this.existClass, 300);
        this.addClassAfterTimeout(this.currentSlide, this.visibleClass, 500);
      }
    },
    setCurrentIndex(currentSlideIndex) {
      currentSlideIndex < 0 && (currentSlideIndex = 0);
      this.currentSlideIndex =
        currentSlideIndex >= this.slidesElements.length ? 0 : currentSlideIndex;
    },
    setCurrentSlide() {
      this.currentSlide = this.slider.querySelector(
        `.${this.getSlideClass(this.currentSlideIndex)}`
      );
    },
    init() {
      this.slider = this.$vnode.elm.querySelector(".slider");
      if (this.slider) {
        this.slidesElements = Array.prototype.slice.call(
          this.slider.querySelectorAll(`.${this.singleSlideClass}`)
        );
        this.pagination = this.slider.querySelector(".pagination");
        this.showSlide();
      }
    },
    clickOnSlide(index) {
      clearInterval(this.autoplayInterval);
      this.showSlide(index);
    },
    autoplay() {
      const iterations = this.slidesElements.length;
      let i = 0;
      this.autoplayInterval = setInterval(() => {
        this.showSlide(i++);
        if (i === iterations) {
          i = 0;
        }
      }, 4000);
    },
  },
  mounted() {
    this.init();
    this.autoplay();
  },
};
</script>

<style lang="scss">
@import "../../scss/colors";
@import "../../scss/utils";

@keyframes bounce {
  0% {
    transform: translateY(0px);
  }

  20% {
    transform: translateY(10px);
  }

  80% {
    transform: translateY(3px);
  }

  100% {
    transform: translateY(0px);
  }
}

.jumbotronWithSlider {
  min-height: 100vh;
  position: relative;

  @include desktop() {
    background-image: url("../../assets/Kancelaria_zdjecia_2019_0012.jpg");
    background-size: cover;
    background-position: center;
  }

  @include mobile() {
    padding-top: 200px !important;
    min-height: 30vh;
  }

  @include untilContainer() {
    .container {
      display: flex;
      justify-content: flex-start;
    }
  }

  .LeafsContainer {
    top: 200px;
    left: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .Leafs {
      opacity: 0.4;
      position: absolute;
      width: 70%;
      height: 100%;

      #Warstwa_1 {
        width: 100%;
        height: 100%;
      }

      &:first-child {
        right: 0;
        transform: rotate(90deg);
      }

      &:last-child {
        left: 0;
        transform: rotate(-80deg);
      }
    }
  }

  .arrow {
    @include mobile() {
      display: none;
    }

    @include desktop() {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      max-width: 40px;
      margin: auto;
      animation: bounce 1s infinite;
      transition: transform 0.3s;
      bottom: -100%;
    }

    &:hover {
      transform: scale(1.1);
    }
  }
}

.slider {
  position: relative;
  width: 100%;
  z-index: 2;
  min-height: 200px;
  margin: auto;

  @include desktop() {
    max-width: 70%;
    margin-bottom: -250px;
  }

  @include mobile() {
    max-width: 600px;
  }

  &-content {
    h2 {
      text-shadow: 0px 0px 5px black;
    }
  }
}

.pagination {
  position: absolute;
  bottom: calc(100% + 20px);

  button {
    border: none;
    background: none;
    color: white;
    opacity: 0.6;
    transition: opacity 0.3s;

    &.active {
      opacity: 1;
    }

    &:focus {
      outline: none;
    }

    &:hover {
      cursor: pointer;
    }
  }
}

.slide {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity 0.3s;
  display: none;

  &.exist {
    display: block;
  }

  &.visible {
    opacity: 1;
  }

  .button {
    margin-top: 20px;
    border-radius: 5px;
    border: solid 1.5px #ffffff;
    color: white;
    min-height: 28px;
    font-size: 12px;
    display: inline-flex;
  }
}
</style>
